import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { setReferralSlug } from '@/lib/referralStorage';

export function useReferralCapture() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (ref) {
      setReferralSlug(ref);
      // Strip the ref param from the URL
      const next = new URLSearchParams(searchParams);
      next.delete('ref');
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams]);
}
